 <template lang="pug">
  v-container.pt-10.custom-container(fluid)
    v-dialog( :fullscreen="isMobile" width="400" persistent :value='detailsDialogReference' transition="dialog-bottom-transition")
      Details(v-if='detailsDialogReference' :request='currentTransaction' @showProduct='productDialog = false' @close ='detailsDialogReference=false' :admin="admin")
    // Confirmation delete
    v-dialog(v-if="confirmationDialog" persistent  :value='confirmationDialog' max-width='300px')
      v-card(style="border: 1px solid")
        v-card-title Borrar registro
          v-spacer
            v-icon(aria-label="Close" @click="confirmationDialog = false") mdi-close
        v-card-text.body-1.text-center ¿Deseas eliminar este registro de la bitacora?
        v-card-actions.text-center
            v-spacer
              v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No
              v-btn(color='red darken-1', flat='', @click.native='deleteNotification(currentNotification)') Si
    // Details
    v-dialog(:fullscreen="isMobile" :value='detailsDialog' width='700' transition="dialog-bottom-transition" style="position: relative;")
      v-card(height="100%").mx-auto
        v-card-title.text-left Detalles de registro
          v-spacer
            v-icon(aria-label="Close" @click="detailsDialog = false; detailsDialogReference = false") mdi-close
        v-divider
        v-card-text
          v-row
            v-col(cols="4" align="center").text-center
              v-row.justify-center.mb-10
                v-icon(size="50" color="#ff4800") mdi-bell-ring-outline
            v-col(cols="8")
              h3 {{currentNotification.title}}
              v-list-item-subtitle {{currentNotification.created | moment}}
              p.mt-5 {{currentNotification.description}}
              // h4.mt-5 Responsable: {{currentNotification.user.name}} {{currentNotification.user.email}}
              p(v-if="currentNotification.reference && currentNotification.reference != '0'" @click="showBill(currentNotification)" style="cursor: pointer;color: #007991;text-decoration-line: underline;") Referencia {{currentNotification.reference}}
              v-progress-circular.ml-1.mt-1(v-if="currentNotification.reference && currentNotification.reference != '0' && loadingDetail" :size="20" :width="2" color="primary" indeterminate)
              p.mt-5
                strong Gracias por usar tender.
        v-divider(v-if="!isMobile")
        v-row(:style="isMobile ? 'position: absolute; bottom: 0; width: 100%; margin-left: 4px' : ''")
          v-btn(block color="primary darken-3" @click="confirmationDialog = true").mb-3
            v-icon mdi-delete
            | Eliminar
    // content
    template(v-if="notifications.length > 0")
      v-card.mx-auto(style="box-shadow: 18px 2px 65px -23px rgba(0,0,0,0.75)")
        v-list-item(three-line="")
          v-list-item-content
            h2 Bienvenido {{profile.name}} {{profile.last_name}}
            p Aqui puedes ver las acciones que se han realizado
          v-list-item-avatar(tile size="80").mr-3
            v-badge(v-if="notifications.length > 0" color="red" :content="notifications.length" overlap="")
              v-icon(size="40"  color="primary") mdi-bell-outline
            v-icon(v-else size="40"  color="primary") mdi-bell-outline
    template(v-if="notifications.length > 0")
      v-card(flat elevation="0" ).notification__container
        v-toolbar.custom-toolbar-wrapper(v-if='!isMobile' dark="" height="50px" color="primary")
          .toolbar-header.mr-auto
            v-row
              h2 {{$t('drawer.logs')}}
        v-card-text.pa-0(style="background: red")
          v-list(two-line="")
            v-list-item-group
              template(v-for="(item, index) in notifications.slice(5*(page-1), 5*(page))")
                v-list-item(:key="item.created" :class="!item.read ? 'notification__noRead':''" @click="openDetail(item)").notification
                  template(v-slot:default="{ active, toggle }")
                    v-list-item-icon(style="margin: auto 1rem auto 0rem;")
                      v-icon(size="30" :color="!item.read ? '#ff4800':''") mdi-bell
                    v-list-item-content
                      p {{item.title}}
                      v-list-item-subtitle.text--primary(v-text="item.description")
                      span.notification__date {{item.created | moment}} {{item.created | momentHours}}
                    v-list-item-action
                      v-btn(icon text)
                        v-icon mdi-chevron-right
                v-divider(v-if="index + 1 < notifications.length" :key="index")
              v-pagination.my-4(v-model="page" :length="pageNumber")
              // v-btn(@click="getLogs(true)" color="primary") Siguiente pagina
    template(v-else)
      noResults( :title="'Aún no tienes registros en la bitacora'" :description="'En esta sección encontraras tus registros'")
</template>

<script>
  import moment from 'moment'
  import loaders from '@/plugins/mixins/loaders'
  import axios from 'axios'
  import * as vars from '@/vars.json'
  export default {
    components: {
      noResults: () => import('@/components/custom/NoResults.vue'),
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
    },
    filters: {
      moment: function (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm')
      },
    },

    mixins: [loaders],
    data () {
      return {
        loadingDetail: false,
        page: 1,
        title: this.$t('drawer.logs'),
        currentTransaction: null,
        detailsDialog: false,
        detailsDialogReference: false,
        confirmationDialog: false,
        currentNotification: '',
        currentType: '',
        admin: '',
        notifications: [],
        limit: 10,
      }
    },

    computed: {
      profile () {
        return this.$store.state.users.profile
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      pageNumber () {
        return Math.ceil(this.notifications.length / 5)
      },
    },

    watch: {
      page (newVal, oldVal) {
        const vm = this
        if (newVal === vm.pageNumber) {
          vm.getLogs(true)
        }
      },
    },

    created () {
      const vm = this
      vm.getLogs()
    },
    methods: {
      getLogs (limit = null) {
        const vm = this
        if (limit) {
          vm.limit += 5
        }
        const data = {
          uid: vm.$store.state.users.user.uid,
          limit: vm.limit,
        }
        axios.post(vars.url + '/getLogs', data).then(res => {
          // console.log(res)
          vm.notifications = res.data.reverse()
        }).catch(e => {
          if (e.response) {
            vm.message = e.response.data.error.message
            vm.show = true
          }
        })
      },
      deleteNotification (notification) {
        const vm = this
        vm.confirmationDialog = false
        vm.detailsDialog = false
        vm.$store.dispatch('transactions/deleteBill', notification).then(() => {
          vm.getLogs()
        })
      },
      openDetail (notification) {
        const vm = this
        // console.log(notification)
        vm.currentNotification = notification
        vm.currentNotification.type = 'logs'
        vm.detailsDialog = true
      },
      async showBill (item) {
        const vm = this
        let bill = ''
        // console.log(item)
        vm.loadingDetail = true
        if (item.reference) {
          // console.log(item.title.toUpperCase().includes('compra'))
          if (item.title.toUpperCase().includes('COMPRA') || item.description.toUpperCase().includes('COMPRA')) {
            // console.log('compra')
            vm.currentType = 'purchases'
          } else if (item.title.toUpperCase().includes('VENTA') || item.description.toUpperCase().includes('VENTA')) {
            // console.log('sales')
            vm.currentType = 'sales'
          } else if (item.title.toUpperCase().includes('ORDEN') && item.description.toUpperCase().includes('ORDEN')) {
            // console.log('orders')
            vm.currentType = 'orders'
          }
          bill = await vm.$store.dispatch('transactions/getItem', [vm.currentType, item.reference]).then(async function (res) {
            const found = await vm.$store.state.transactions.currentRequest
            return found
          })
        }
        if (bill) {
          vm.currentTransaction = Object.values(bill)[0]
          if (vm.currentType === 'orders') {
            vm.admin = 'order'
          } else if (vm.currentType === 'sales') {
            vm.admin = 'sale'
          } else if (vm.currentType === 'purchases') {
            vm.admin = 'purchase'
          } else {
            vm.admin = 'request'
          }
          vm.detailsDialogReference = true
          vm.loadingDetail = false
        }
      },
    },
  }
</script>

<style lang='scss' scoped>
.notification{
  display: flex;
  width: 95%;
  margin: 0 auto;
  // border-radius: 10px !important;
  box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
  &__container{
    @media (max-width: 1024px){
      background: transparent;
    }
  }
  &__noRead{
    border-left: 4px solid #ff4800;
    font-weight: bold;
  }
  &__title{
    font-size: 20px;
    color: #808184;
  }
  &__date{
    color: var(--font-color-2) !important;
  }
  &__time{
    color: #808184;
  }
  &__description{
    color: #808184;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.2;
  }
}
</style>
